import { render } from "./absensi-instruktur.vue?vue&type=template&id=06c256d8"
import script from "./absensi-instruktur.vue?vue&type=script&lang=js"
export * from "./absensi-instruktur.vue?vue&type=script&lang=js"

import "./absensi-instruktur.vue?vue&type=style&index=0&id=06c256d8&lang=css"

import exportComponent from "/home/alfahuma/manual_build/digita-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__